import { MapPin, Clock, Phone, MessageCircle, Navigation } from "lucide-react";
import { STORE, waLink } from "../data/store";

export const LocationContact = () => {
  return (
    <section id="section-contacto" className="scroll-mt-20 py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-xs font-bold tracking-widest uppercase text-[#E02424]">Visitanos</div>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mt-1">
              Estamos en Hernandarias
            </h2>
            <p className="mt-3 text-gray-600 max-w-lg">
              Pasá por nuestra tienda física. Te asesoramos con tu proyecto y preparamos tu color en el laboratorio.
            </p>

            <div className="mt-6 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-[#0067B1]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Dirección</div>
                  <div className="text-gray-600">{STORE.address}</div>
                  <div className="text-gray-600">{STORE.city}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-amber-50 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-[#D97706]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Horario</div>
                  <div className="text-gray-600">{STORE.hours}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-[#15803D]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Teléfono / WhatsApp</div>
                  <div className="text-gray-600">{STORE.phoneDisplay}</div>
                </div>
              </div>
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                data-testid="contacto-whatsapp"
                href={waLink(`Hola ${STORE.name}, quiero hacer una consulta.`)}
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#25D366] text-white font-bold hover:bg-[#1EBE5B] transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> Escribir por WhatsApp
              </a>
              <a
                data-testid="contacto-maps"
                href="https://www.google.com/maps/search/?api=1&query=Av.+Fulgencio+Yegros+y+Mariscal+Lopez+Hernandarias+Paraguay"
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#0A3977] text-white font-bold hover:bg-[#0067B1] transition-colors"
              >
                <Navigation className="w-4 h-4" /> Cómo llegar
              </a>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-lg h-[360px]">
            <iframe
              title="Ubicación Pinturería Yegros"
              data-testid="map-iframe"
              className="w-full h-full"
              loading="lazy"
              src="https://www.google.com/maps?q=Av.+Fulgencio+Yegros+y+Mariscal+Lopez+Hernandarias+Paraguay&output=embed"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
